"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Web3ApiClient = void 0;
var default_client_config_1 = require("./default-client-config");
var PluginWeb3Api_1 = require("./plugin/PluginWeb3Api");
var wasm_1 = require("./wasm");
var uuid_1 = require("uuid");
var core_js_1 = require("@web3api/core-js");
var tracing_js_1 = require("@web3api/tracing-js");
var Web3ApiClient = /** @class */ (function () {
    function Web3ApiClient(config, options) {
        // TODO: the API cache needs to be more like a routing table.
        // It should help us keep track of what URI's map to what APIs,
        // and handle cases where the are multiple jumps. For example, if
        // A => B => C, then the cache should have A => C, and B => C.
        this._apiCache = new Map();
        this._config = {
            redirects: [],
            plugins: [],
            interfaces: [],
            envs: [],
            tracingEnabled: false,
        };
        // Invoke specific contexts
        this._contexts = new Map();
        try {
            this.setTracingEnabled(!!(config === null || config === void 0 ? void 0 : config.tracingEnabled));
            tracing_js_1.Tracer.startSpan("Web3ApiClient: constructor");
            if (config) {
                this._config = {
                    redirects: config.redirects
                        ? core_js_1.sanitizeUriRedirects(config.redirects)
                        : [],
                    envs: config.envs ? core_js_1.sanitizeEnvs(config.envs) : [],
                    plugins: config.plugins
                        ? core_js_1.sanitizePluginRegistrations(config.plugins)
                        : [],
                    interfaces: config.interfaces
                        ? core_js_1.sanitizeInterfaceImplementations(config.interfaces)
                        : [],
                    tracingEnabled: !!config.tracingEnabled,
                };
            }
            if (!(options === null || options === void 0 ? void 0 : options.noDefaults)) {
                this._addDefaultConfig();
            }
            this._validateConfig();
            tracing_js_1.Tracer.setAttribute("config", this._config);
        }
        catch (error) {
            tracing_js_1.Tracer.recordException(error);
            throw error;
        }
        finally {
            tracing_js_1.Tracer.endSpan();
        }
    }
    Web3ApiClient.prototype.setTracingEnabled = function (enable) {
        if (enable) {
            tracing_js_1.Tracer.enableTracing("Web3ApiClient");
        }
        else {
            tracing_js_1.Tracer.disableTracing();
        }
        this._config.tracingEnabled = enable;
    };
    Web3ApiClient.prototype.getRedirects = function (options) {
        if (options === void 0) { options = {}; }
        return this._getConfig(options.contextId).redirects;
    };
    Web3ApiClient.prototype.getPlugins = function (options) {
        if (options === void 0) { options = {}; }
        return this._getConfig(options.contextId).plugins;
    };
    Web3ApiClient.prototype.getInterfaces = function (options) {
        if (options === void 0) { options = {}; }
        return this._getConfig(options.contextId).interfaces;
    };
    Web3ApiClient.prototype.getEnvs = function (options) {
        if (options === void 0) { options = {}; }
        return this._getConfig(options.contextId).envs;
    };
    Web3ApiClient.prototype.getEnvByUri = function (uri, options) {
        var uriUri = this._toUri(uri);
        return this.getEnvs(options).find(function (environment) {
            return core_js_1.Uri.equals(environment.uri, uriUri);
        });
    };
    Web3ApiClient.prototype.getSchema = function (uri, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var api, client;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._loadWeb3Api(this._toUri(uri), options.contextId)];
                    case 1:
                        api = _a.sent();
                        client = contextualizeClient(this, options.contextId);
                        return [4 /*yield*/, api.getSchema(client)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Web3ApiClient.prototype.getManifest = function (uri, options) {
        return __awaiter(this, void 0, void 0, function () {
            var api, client;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._loadWeb3Api(this._toUri(uri), options.contextId)];
                    case 1:
                        api = _a.sent();
                        client = contextualizeClient(this, options.contextId);
                        return [4 /*yield*/, api.getManifest(options, client)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Web3ApiClient.prototype.getFile = function (uri, options) {
        return __awaiter(this, void 0, void 0, function () {
            var api, client;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._loadWeb3Api(this._toUri(uri), options.contextId)];
                    case 1:
                        api = _a.sent();
                        client = contextualizeClient(this, options.contextId);
                        return [4 /*yield*/, api.getFile(options, client)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Web3ApiClient.prototype.getImplementations = function (uri, options) {
        if (options === void 0) { options = {}; }
        var isUriTypeString = typeof uri === "string";
        var applyRedirects = !!options.applyRedirects;
        return isUriTypeString
            ? core_js_1.getImplementations(this._toUri(uri), this.getInterfaces(options), applyRedirects ? this.getRedirects(options) : undefined).map(function (x) { return x.uri; })
            : core_js_1.getImplementations(this._toUri(uri), this.getInterfaces(options), applyRedirects ? this.getRedirects(options) : undefined);
    };
    Web3ApiClient.prototype.query = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, contextId, shouldClearContext, result, typedOptions, uri, query, variables, queryDocument, queryInvocations, parallelInvocations, _loop_1, this_1, _b, _c, invocationName, invocationResults, data, errors, invocationResults_1, invocationResults_1_1, invocation, error_1;
            var e_1, _d, e_2, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _a = this._setContext(options.contextId, options.config), contextId = _a.contextId, shouldClearContext = _a.shouldClearContext;
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 3, , 4]);
                        typedOptions = __assign(__assign({}, options), { uri: this._toUri(options.uri) });
                        uri = typedOptions.uri, query = typedOptions.query, variables = typedOptions.variables;
                        queryDocument = typeof query === "string" ? core_js_1.createQueryDocument(query) : query;
                        queryInvocations = core_js_1.parseQuery(uri, queryDocument, variables);
                        parallelInvocations = [];
                        _loop_1 = function (invocationName) {
                            parallelInvocations.push(this_1.invoke(__assign(__assign({}, queryInvocations[invocationName]), { uri: queryInvocations[invocationName].uri, contextId: contextId })).then(function (result) { return ({
                                name: invocationName,
                                result: result,
                            }); }));
                        };
                        this_1 = this;
                        try {
                            for (_b = __values(Object.keys(queryInvocations)), _c = _b.next(); !_c.done; _c = _b.next()) {
                                invocationName = _c.value;
                                _loop_1(invocationName);
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_d = _b.return)) _d.call(_b);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        return [4 /*yield*/, Promise.all(parallelInvocations)];
                    case 2:
                        invocationResults = _f.sent();
                        tracing_js_1.Tracer.addEvent("invocationResults", invocationResults);
                        data = {};
                        errors = [];
                        try {
                            for (invocationResults_1 = __values(invocationResults), invocationResults_1_1 = invocationResults_1.next(); !invocationResults_1_1.done; invocationResults_1_1 = invocationResults_1.next()) {
                                invocation = invocationResults_1_1.value;
                                data[invocation.name] = invocation.result.data;
                                if (invocation.result.error) {
                                    errors.push(invocation.result.error);
                                }
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (invocationResults_1_1 && !invocationResults_1_1.done && (_e = invocationResults_1.return)) _e.call(invocationResults_1);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        result = {
                            data: data,
                            errors: errors.length === 0 ? undefined : errors,
                        };
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _f.sent();
                        if (Array.isArray(error_1)) {
                            result = { errors: error_1 };
                        }
                        else {
                            result = { errors: [error_1] };
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        if (shouldClearContext) {
                            this._clearContext(contextId);
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    Web3ApiClient.prototype.invoke = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, contextId, shouldClearContext, result, typedOptions, api, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this._setContext(options.contextId, options.config), contextId = _a.contextId, shouldClearContext = _a.shouldClearContext;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        typedOptions = __assign(__assign({}, options), { contextId: contextId, uri: this._toUri(options.uri) });
                        return [4 /*yield*/, this._loadWeb3Api(typedOptions.uri, contextId)];
                    case 2:
                        api = _b.sent();
                        return [4 /*yield*/, api.invoke(typedOptions, contextualizeClient(this, contextId))];
                    case 3:
                        result = (_b.sent());
                        return [3 /*break*/, 5];
                    case 4:
                        error_2 = _b.sent();
                        result = { error: error_2 };
                        return [3 /*break*/, 5];
                    case 5:
                        if (shouldClearContext) {
                            this._clearContext(contextId);
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    Web3ApiClient.prototype.subscribe = function (options) {
        var _a;
        var _b, _c, _d, _e;
        var _f = this._setContext(options.contextId, options.config), contextId = _f.contextId, shouldClearContext = _f.shouldClearContext;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var thisClient = this;
        var client = contextualizeClient(this, contextId);
        var typedOptions = __assign(__assign({}, options), { uri: this._toUri(options.uri) });
        var uri = typedOptions.uri, query = typedOptions.query, variables = typedOptions.variables, freq = typedOptions.frequency;
        // calculate interval between queries, in milliseconds, 1 min default value
        /* eslint-disable prettier/prettier */
        var frequency;
        if (freq && (freq.ms || freq.sec || freq.min || freq.hours)) {
            frequency =
                ((_b = freq.ms) !== null && _b !== void 0 ? _b : 0) +
                    (((_c = freq.hours) !== null && _c !== void 0 ? _c : 0) * 3600 +
                        ((_d = freq.min) !== null && _d !== void 0 ? _d : 0) * 60 +
                        ((_e = freq.sec) !== null && _e !== void 0 ? _e : 0)) *
                        1000;
        }
        else {
            frequency = 60000;
        }
        /* eslint-enable  prettier/prettier */
        var subscription = (_a = {
                frequency: frequency,
                isActive: false,
                stop: function () {
                    if (shouldClearContext) {
                        thisClient._clearContext(contextId);
                    }
                    subscription.isActive = false;
                }
            },
            _a[Symbol.asyncIterator] = function () {
                return __asyncGenerator(this, arguments, function _a() {
                    var timeout, readyVals_1, sleep_1, result;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                timeout = undefined;
                                subscription.isActive = true;
                                _b.label = 1;
                            case 1:
                                _b.trys.push([1, , 11, 12]);
                                readyVals_1 = 0;
                                timeout = setInterval(function () {
                                    readyVals_1++;
                                    if (sleep_1) {
                                        sleep_1();
                                        sleep_1 = undefined;
                                    }
                                }, frequency);
                                _b.label = 2;
                            case 2:
                                if (!subscription.isActive) return [3 /*break*/, 10];
                                if (!(readyVals_1 === 0)) return [3 /*break*/, 4];
                                return [4 /*yield*/, __await(new Promise(function (r) { return (sleep_1 = r); }))];
                            case 3:
                                _b.sent();
                                _b.label = 4;
                            case 4:
                                if (!(readyVals_1 > 0)) return [3 /*break*/, 9];
                                if (!subscription.isActive) {
                                    return [3 /*break*/, 9];
                                }
                                return [4 /*yield*/, __await(client.query({
                                        uri: uri,
                                        query: query,
                                        variables: variables,
                                        contextId: contextId,
                                    }))];
                            case 5:
                                result = _b.sent();
                                return [4 /*yield*/, __await(result)];
                            case 6: return [4 /*yield*/, _b.sent()];
                            case 7:
                                _b.sent();
                                _b.label = 8;
                            case 8:
                                readyVals_1--;
                                return [3 /*break*/, 4];
                            case 9: return [3 /*break*/, 2];
                            case 10: return [3 /*break*/, 12];
                            case 11:
                                if (timeout) {
                                    clearInterval(timeout);
                                }
                                if (shouldClearContext) {
                                    thisClient._clearContext(contextId);
                                }
                                subscription.isActive = false;
                                return [7 /*endfinally*/];
                            case 12: return [2 /*return*/];
                        }
                    });
                });
            },
            _a);
        return subscription;
    };
    Web3ApiClient.prototype._addDefaultConfig = function () {
        var _a, _b, _c;
        var defaultClientConfig = default_client_config_1.getDefaultClientConfig();
        if (defaultClientConfig.redirects) {
            (_a = this._config.redirects).push.apply(_a, __spread(defaultClientConfig.redirects));
        }
        if (defaultClientConfig.plugins) {
            (_b = this._config.plugins).push.apply(_b, __spread(defaultClientConfig.plugins));
        }
        if (defaultClientConfig.interfaces) {
            (_c = this._config.interfaces).push.apply(_c, __spread(defaultClientConfig.interfaces));
        }
    };
    Web3ApiClient.prototype._isContextualized = function (contextId) {
        return !!contextId && this._contexts.has(contextId);
    };
    Web3ApiClient.prototype._getConfig = function (contextId) {
        if (contextId) {
            var context = this._contexts.get(contextId);
            if (!context) {
                throw new Error("No invoke context found with id: " + contextId);
            }
            return context;
        }
        else {
            return this._config;
        }
    };
    Web3ApiClient.prototype._validateConfig = function () {
        // Require plugins to use non-interface URIs
        var pluginUris = this.getPlugins().map(function (x) { return x.uri.uri; });
        var interfaceUris = this.getInterfaces().map(function (x) { return x.interface.uri; });
        var pluginsWithInterfaceUris = pluginUris.filter(function (plugin) {
            return interfaceUris.includes(plugin);
        });
        if (pluginsWithInterfaceUris.length) {
            throw Error("Plugins can't use interfaces for their URI. Invalid plugins: " + pluginsWithInterfaceUris);
        }
    };
    Web3ApiClient.prototype._toUri = function (uri) {
        if (typeof uri === "string") {
            return new core_js_1.Uri(uri);
        }
        else if (core_js_1.Uri.isUri(uri)) {
            return uri;
        }
        else {
            throw Error("Unknown uri type, cannot convert. " + JSON.stringify(uri));
        }
    };
    /**
     * Sets invoke context:
     *  1. !parentId && !context  -> do nothing
     *  2. parentId && !context   -> do nothing, use parent context ID
     *  3. !parentId && context   -> create context ID, default config as "base", cache context
     *  4. parentId && context    -> create context ID, parent config as "base", cache context
     */
    Web3ApiClient.prototype._setContext = function (parentId, context) {
        if (!context) {
            return {
                contextId: parentId,
                shouldClearContext: false,
            };
        }
        var config = this._getConfig(parentId);
        var id = uuid_1.v4();
        this._contexts.set(id, {
            redirects: (context === null || context === void 0 ? void 0 : context.redirects) ? core_js_1.sanitizeUriRedirects(context.redirects)
                : config.redirects,
            plugins: (context === null || context === void 0 ? void 0 : context.plugins) ? core_js_1.sanitizePluginRegistrations(context.plugins)
                : config.plugins,
            interfaces: (context === null || context === void 0 ? void 0 : context.interfaces) ? core_js_1.sanitizeInterfaceImplementations(context.interfaces)
                : config.interfaces,
            envs: (context === null || context === void 0 ? void 0 : context.envs) ? core_js_1.sanitizeEnvs(context.envs) : config.envs,
            tracingEnabled: (context === null || context === void 0 ? void 0 : context.tracingEnabled) || config.tracingEnabled,
        });
        return {
            contextId: id,
            shouldClearContext: true,
        };
    };
    Web3ApiClient.prototype._clearContext = function (contextId) {
        if (contextId) {
            this._contexts.delete(contextId);
        }
    };
    Web3ApiClient.prototype._loadWeb3Api = function (uri, contextId) {
        return __awaiter(this, void 0, void 0, function () {
            var typedUri, ignoreCache, api, client_1, config, environment_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        typedUri = typeof uri === "string" ? new core_js_1.Uri(uri) : uri;
                        ignoreCache = this._isContextualized(contextId);
                        api = ignoreCache ? undefined : this._apiCache.get(uri.uri);
                        if (!!api) return [3 /*break*/, 2];
                        client_1 = contextualizeClient(this, contextId);
                        config = this._getConfig(contextId);
                        environment_1 = this.getEnvByUri(typedUri, { contextId: contextId });
                        return [4 /*yield*/, core_js_1.resolveUri(typedUri, config.redirects, config.plugins, config.interfaces, function (options) {
                                return client_1.invoke(options);
                            }, function (uri, plugin) {
                                return new PluginWeb3Api_1.PluginWeb3Api(uri, plugin, environment_1);
                            }, function (uri, manifest, uriResolver) {
                                return new wasm_1.WasmWeb3Api(uri, manifest, uriResolver, environment_1);
                            })];
                    case 1:
                        api = _a.sent();
                        if (!api) {
                            throw Error("Unable to resolve Web3API at uri: " + typedUri);
                        }
                        if (!ignoreCache) {
                            this._apiCache.set(typedUri.uri, api);
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, api];
                }
            });
        });
    };
    __decorate([
        tracing_js_1.Tracer.traceMethod("Web3ApiClient: getRedirects")
    ], Web3ApiClient.prototype, "getRedirects", null);
    __decorate([
        tracing_js_1.Tracer.traceMethod("Web3ApiClient: getPlugins")
    ], Web3ApiClient.prototype, "getPlugins", null);
    __decorate([
        tracing_js_1.Tracer.traceMethod("Web3ApiClient: getInterfaces")
    ], Web3ApiClient.prototype, "getInterfaces", null);
    __decorate([
        tracing_js_1.Tracer.traceMethod("Web3ApiClient: getEnvs")
    ], Web3ApiClient.prototype, "getEnvs", null);
    __decorate([
        tracing_js_1.Tracer.traceMethod("Web3ApiClient: getEnvByUri")
    ], Web3ApiClient.prototype, "getEnvByUri", null);
    __decorate([
        tracing_js_1.Tracer.traceMethod("Web3ApiClient: getSchema")
    ], Web3ApiClient.prototype, "getSchema", null);
    __decorate([
        tracing_js_1.Tracer.traceMethod("Web3ApiClient: getManifest")
    ], Web3ApiClient.prototype, "getManifest", null);
    __decorate([
        tracing_js_1.Tracer.traceMethod("Web3ApiClient: getFile")
    ], Web3ApiClient.prototype, "getFile", null);
    __decorate([
        tracing_js_1.Tracer.traceMethod("Web3ApiClient: getImplementations")
    ], Web3ApiClient.prototype, "getImplementations", null);
    __decorate([
        tracing_js_1.Tracer.traceMethod("Web3ApiClient: query")
    ], Web3ApiClient.prototype, "query", null);
    __decorate([
        tracing_js_1.Tracer.traceMethod("Web3ApiClient: invoke")
    ], Web3ApiClient.prototype, "invoke", null);
    __decorate([
        tracing_js_1.Tracer.traceMethod("Web3ApiClient: subscribe")
    ], Web3ApiClient.prototype, "subscribe", null);
    __decorate([
        tracing_js_1.Tracer.traceMethod("Web3ApiClient: isContextualized")
    ], Web3ApiClient.prototype, "_isContextualized", null);
    __decorate([
        tracing_js_1.Tracer.traceMethod("Web3ApiClient: getConfig")
    ], Web3ApiClient.prototype, "_getConfig", null);
    __decorate([
        tracing_js_1.Tracer.traceMethod("Web3ApiClient: validateConfig")
    ], Web3ApiClient.prototype, "_validateConfig", null);
    __decorate([
        tracing_js_1.Tracer.traceMethod("Web3ApiClient: toUri")
    ], Web3ApiClient.prototype, "_toUri", null);
    __decorate([
        tracing_js_1.Tracer.traceMethod("Web3ApiClient: setContext")
    ], Web3ApiClient.prototype, "_setContext", null);
    __decorate([
        tracing_js_1.Tracer.traceMethod("Web3ApiClient: clearContext")
    ], Web3ApiClient.prototype, "_clearContext", null);
    __decorate([
        tracing_js_1.Tracer.traceMethod("Web3ApiClient: _loadWeb3Api")
    ], Web3ApiClient.prototype, "_loadWeb3Api", null);
    return Web3ApiClient;
}());
exports.Web3ApiClient = Web3ApiClient;
var contextualizeClient = function (client, contextId) {
    return contextId
        ? {
            query: function (options) {
                return client.query(__assign(__assign({}, options), { contextId: contextId }));
            },
            invoke: function (options) {
                return client.invoke(__assign(__assign({}, options), { contextId: contextId }));
            },
            subscribe: function (options) {
                return client.subscribe(__assign(__assign({}, options), { contextId: contextId }));
            },
            getRedirects: function (options) {
                if (options === void 0) { options = {}; }
                return client.getRedirects(__assign(__assign({}, options), { contextId: contextId }));
            },
            getPlugins: function (options) {
                if (options === void 0) { options = {}; }
                return client.getPlugins(__assign(__assign({}, options), { contextId: contextId }));
            },
            getInterfaces: function (options) {
                if (options === void 0) { options = {}; }
                return client.getInterfaces(__assign(__assign({}, options), { contextId: contextId }));
            },
            getEnvs: function (options) {
                if (options === void 0) { options = {}; }
                return client.getEnvs(__assign(__assign({}, options), { contextId: contextId }));
            },
            getEnvByUri: function (uri, options) {
                if (options === void 0) { options = {}; }
                return client.getEnvByUri(uri, __assign(__assign({}, options), { contextId: contextId }));
            },
            getSchema: function (uri, options) {
                if (options === void 0) { options = {}; }
                return client.getSchema(uri, __assign(__assign({}, options), { contextId: contextId }));
            },
            getManifest: function (uri, options) {
                return client.getManifest(uri, __assign(__assign({}, options), { contextId: contextId }));
            },
            getFile: function (uri, options) {
                return client.getFile(uri, options);
            },
            getImplementations: function (uri, options) {
                if (options === void 0) { options = {}; }
                return client.getImplementations(uri, __assign(__assign({}, options), { contextId: contextId }));
            },
        }
        : client;
};
//# sourceMappingURL=Web3ApiClient.js.map